import { dangerouslyGetFeatureGateSync } from '@trello/feature-gate-client';
import type { FeatureGateKeys } from '@trello/feature-gates';

let gateCache: Partial<Record<FeatureGateKeys, boolean>> = {};

/**
 * A function to evaluate whether a feature gate is enabled in a stable manner.
 * Results are cached after the first evaluation.
 */
export const isGateEnabled = (gate: FeatureGateKeys): boolean => {
  if (gateCache[gate] === undefined) {
    gateCache[gate] = dangerouslyGetFeatureGateSync(gate);
  }
  return gateCache[gate]!;
};

/**
 * Used for testing purposes to reset the internal cache.
 */
export const resetCache = () => {
  gateCache = {};
};
